import L from "leaflet";
import { useCallback, useEffect, useMemo } from "react";
import { useMapEvents } from "react-leaflet";
import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
import { useMapContext } from "context/MapContextProvider";

import { MapModes } from "constant";
import features from "features";
// import { isPointInBounds } from "helpers/isPointInBounds";
import { RootStateInterface } from "reducer";
import { LayersManagerStateInterface } from "scenes/LayersManager/interfaces";
import usePointHandler from "scenes/MapPage/usePointHandler";
import { UnitsManagerStateInterface } from "scenes/UnitsManager/interfaces";

import PlusIcon from "assets/icons/plus-black.svg";
// import TrashIcon from "assets/icons/trash.svg";

interface MapEventHandlerInterface {
  mode: MapModes;
  activePolygon?: any;
}

const MapEventHandler = ({ mode }: MapEventHandlerInterface) => {
  const { layers } = useSelector<
    RootStateInterface,
    LayersManagerStateInterface
  >((state) => state.layersManager);
  const { createPoint } = usePointHandler();
  const { openContextMenu, closeContextMenu, setPointCoordinates } =
    useMapContext();

  const dispatch = useDispatch();
  // const { id } = useParams();

  const selectedLayers = useMemo(() => {
    return layers.filter((layer) => layer.isActive);
  }, [layers]);

  const { creationPolygonParameters, creationPolygonHistory, isHistoryFrozen } =
    useSelector<RootStateInterface, UnitsManagerStateInterface>(
      (state) => state.unitsManager
    );

  const undoLastAction = useCallback(
    (isHistoryFrozen) => {
      if (
        !isHistoryFrozen &&
        creationPolygonHistory.length > 0 &&
        creationPolygonParameters.id ===
          creationPolygonHistory[creationPolygonHistory.length - 1].id
      ) {
        dispatch(features.unitsManager.actions.returnToPreviousHistoryStep());
      }
    },
    [dispatch, creationPolygonHistory, creationPolygonParameters]
  );

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.code === "KeyZ") {
        undoLastAction(isHistoryFrozen);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [undoLastAction, isHistoryFrozen]);

  // const onDeleteLayerItem = useCallback(
  //   (item) => {
  //     if (item) {
  //       closeAllMenus();
  //       // http://10.10.90.250:8000/map/project/296/task/efc9e804-a6cf-4a1e-84a1-ba957fa04f81/
  //       // http://10.10.90.250:8000/map/project/264/task/f9901e46-b076-453c-bde4-7a4ff89399e9/
  //       const { alias, value: providerId } = item;

  //       dispatch(
  //         features.modal.actions.showModal({
  //           modalType: "DELETE",
  //           modalProps: {
  //             title: `Delete ${item.label}?`,
  //             subtitle: `Are you sure you want to delete ${item.label}? This action cannot be undone.`,
  //             onAcceptClick: () => {
  //               dispatch(
  //                 features.layersManager.actions.deleteProviderRequest({
  //                   params: { id, alias, providerId }
  //                 })
  //               );
  //               dispatch(features.modal.actions.hideModal());
  //             }
  //           }
  //         })
  //       );
  //     }
  //   },
  //   [dispatch, id, setContextMenu]
  // );

  const onCreatePointClick = useCallback(
    (option) => {
      createPoint({
        onCreatePointSuccess: () => {},
        coordinates: option.value
      });
    },
    [createPoint]
  );

  const eventHandlers: Record<MapModes, any> = {
    [MapModes.DEFAULT]: {
      click: () => {
        closeContextMenu();
      },
      contextmenu: (event: L.LeafletMouseEvent) => {
        // const clickedPoint = event.latlng;

        const { lat, lng } = event.latlng;
        const clickedPointCoordinates = { lat, lng };

        const containerPoint = event.containerPoint;

        selectedLayers.map((layer) => layer.providers);

        const options = [
          // ...selectedLayers.reduce((acc, layer) => {
          //   if (Array.isArray(layer.providers)) {
          //     layer.providers.forEach((provider) => {
          //       if (
          //         provider.data.bounds &&
          //         isPointInBounds(clickedPoint, provider.data.bounds)
          //       ) {
          //         const option = {
          //           label: provider.data.name,
          //           value: provider.id,
          //           icon: TrashIcon,
          //           alias: layer.alias,
          //           action: onDeleteLayerItem
          //         };

          //         acc.push(option);
          //       }
          //     });
          //   }
          //   return acc;
          // }, []),
          {
            label: "Add point",
            value: clickedPointCoordinates,
            icon: PlusIcon,
            action: onCreatePointClick
          }
        ];

        openContextMenu({
          position: { x: containerPoint.x, y: containerPoint.y },
          options
        });
      }
    },
    [MapModes.POLYGON_CREATION]: {
      click: (e: L.LeafletMouseEvent) => {
        const { lat, lng } = e.latlng;
        dispatch(
          features.unitsManager.actions.updateCreationPolygonParameters({
            ...creationPolygonParameters,
            geo_data: {
              ...creationPolygonParameters.geo_data,
              coordinates: [
                ...creationPolygonParameters.geo_data.coordinates,
                [lat, lng]
              ]
            }
          })
        );
      },
      contextmenu: () => {
        undoLastAction(isHistoryFrozen);
      }
    },
    [MapModes.MISSION_POLYGON_CREATION]: {
      click: (e: L.LeafletMouseEvent) => {
        const { lat, lng } = e.latlng;
        dispatch(
          features.unitsManager.actions.updateCreationPolygonParameters({
            ...creationPolygonParameters,
            geo_data: {
              ...creationPolygonParameters.geo_data,
              coordinates: [
                ...creationPolygonParameters.geo_data.coordinates,
                [lat, lng]
              ]
            }
          })
        );
      },
      contextmenu: () => {
        undoLastAction(isHistoryFrozen);
      }
    },
    [MapModes.SEARCH_POINT]: {
      click: (e) => {
        const { lat, lng } = e.latlng;
        setPointCoordinates({ lat, lng });
      },
      contextmenu: () => {}
    },
    [MapModes.MISSION_VEHICLE_POINT_CREATION]: undefined
  };

  useMapEvents({
    click: eventHandlers[mode]?.click ?? (() => {}),
    contextmenu: eventHandlers[mode]?.contextmenu ?? (() => {})
  });

  return null;
};

export default MapEventHandler;
